import {Pipe, PipeTransform} from '@angular/core';
import {TriggerEvents} from '../../models/trigger-events';

@Pipe({
  name: 'allowsTime'
})
export class AllowsTimePipe implements PipeTransform {
  transform(event: string): boolean {
    return TriggerEvents.isTime(event);
  }
}
